import { Box, HStack, Icon, Text, Circle } from '@chakra-ui/react'
import { ContentType } from '../../types/content/content'

interface TypeButtonProps {
  label: string
  icon: React.ElementType
  contentType: string
  selectedType: string | ContentType | undefined
  handleRadioChange: (contentType: string | ContentType | undefined) => void
}

const TypeButton: React.FC<TypeButtonProps> = ({
  label,
  icon: IconComponent,
  contentType,
  selectedType,
  handleRadioChange,
}) => {
  return (
    <Box
      as="button"
      borderWidth="1px"
      borderRadius="md"
      p={'8px 10px 8px 12px'}
      bg={selectedType === contentType ? '#09194821' : 'solid.0'}
      borderColor={selectedType === contentType ? 'alpha.900' : 'solid.100'}
      onClick={() => handleRadioChange(contentType)}
      width="100%"
      cursor="pointer"
      _focus={{
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.900',
        outline: 'white',
      }}
      _hover={{
        boxShadow: 'none',
        border: 'solid.100',
        borderColor: 'solid.900',
        outline: 'white',
      }}
    >
      <HStack justifyContent="space-between" alignItems="center">
        <HStack spacing="6px">
          <Icon width="20px" height="20px" fill="none" color="solid.500">
            <IconComponent />
          </Icon>
          <Text textStyle="l-xs">{label}</Text>
        </HStack>
        <Circle
          size="13px"
          borderColor={selectedType === contentType ? 'solid.900' : '#DFE1E6'}
          borderWidth="0.83px"
          bg={selectedType === contentType ? 'solid.900' : 'solid.0'}
          cursor={'pointer'}
        >
          {selectedType === contentType && <Circle size="5px" bg="solid.0" />}
        </Circle>
      </HStack>
    </Box>
  )
}

export default TypeButton
